// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__FxbtT","item":"Breadcrumbs_item__iwCea","ant-breadcrumb-separator":"Breadcrumbs_ant-breadcrumb-separator__quE0N"};